import React from "react";

import Row from "components/Row";
import Icon from "components/Icon";
import styled from "styled-components";
import Column from "components/Column";
import Button from "components/Buttons";
import Section from "components/Section";
import Separator from "components/Separator";

import formatMetricValue from "modules/utils/formatMetricValue";

import { Text, TextDescription, TextTitle } from "components/Texts";
import { useTranslation } from "react-i18next";

import colors from "styles/colors";
import { useHistory } from "react-router-dom";

const TopKeyword = ({ topKeyword, date }) => {
  const [t] = useTranslation();
  const history = useHistory();
  console.log("top Keyword", topKeyword);
  const medalIcons = ["icon-place-1st", "icon-place-2nd", "icon-place-3rd", "icon-place-4th", "icon-place-5th"];

  let keywordTop5 = [];
  if (topKeyword) {
    for (var i = 0; i < topKeyword.length; i++) {
      console.log("topKeywordPush");
      if (keywordTop5.length < 5) {
        keywordTop5.push({
          keyword: topKeyword[i].keyword,
          campaign: topKeyword[i].campaign,
          click: formatMetricValue("click", topKeyword[i].clicks),
          iconName: medalIcons[i],
        });
      } else {
        break;
      }
    }
  }
  console.log("keywordTop5", keywordTop5);

  const EmptyContent = () => {
    const [t] = useTranslation();
    return (
      <StyledEmptyContainer>
        <p>{t("__no_data")}</p>
      </StyledEmptyContainer>
    );
  };

  console.log("keywordTop5", keywordTop5);
  const list = keywordTop5.map((item, index) => (
    <Column className="item" key={index}>
      <Row alignItems="flex-end" columnSpacing="2px">
        <Icon name={item.iconName} size="20px" color={colors.primary}></Icon>
        <TextDescription className="top-keyword" size="10px">
          {t("__dashboard_top_keyword")}
        </TextDescription>
      </Row>
      <Text>{item.keyword}</Text>
      <Separator />
      <TextDescription size="10px">{t("__dashboard_top_campaign")}</TextDescription>
      <Text size="10px" className="top-keyword campaign-name" tooltip ellipsis={2}>
        {item.campaign}
      </Text>
      <Separator />
      <TextDescription size="10px">{t("__dashboard_top_click")}</TextDescription>
      <Text size="10px">{item.click}</Text>
    </Column>
  ));

  return (
    <StyledContainer margin="0 0 24px" padding="24px">
      <Row responsive>
        <Column>
          <Row>
            <Column>
              <TextTitle>{t("__top_5_keywords")}</TextTitle>
              <TextDescription>{date}</TextDescription>
            </Column>
          </Row>
        </Column>
        <Column className="btn-container" wrap>
          <Button
            align="center"
            type="secondary"
            onClick={() => {
              history.push("/search-campaigns");
            }}
            round
          >
            {t("__see_all_keywords")}
          </Button>
        </Column>
      </Row>
      <Separator />
      {list.length ? <Row className="top-keyword-container">{list}</Row> : <EmptyContent />}
    </StyledContainer>
  );
};

const StyledContainer = styled(Section)`
  .item {
    margin: 36px 0;
  }
  @media screen and (max-width: 834px) {
    .btn-container {
      width: 100%;
    }
    .item {
      margin: 0 0 36px !important;

      .top-keyword.campaign-name {
        min-height: unset;
      }
    }

    .top-keyword-container {
      flex-wrap: wrap;
      > .column {
        width: 50%;
      }
    }
  }
`;

const StyledEmptyContainer = styled.div`
  min-height: 100px;
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
  color: ${colors.descriptionText};
`;

export default TopKeyword;
